// Flex column shell (docs/06-ux-rules.md "Height model" / P10 D2): the
// inbox is viewport-bound, not `calc(100vh - magic)`. It wraps the inbox
// mount itself (not the whole host page) and fills from wherever it mounts
// down to the bottom of the window — `useViewportTopOffset` measures the
// chrome above it (navbar, PageHeader, tab bar) instead of hard-coding an
// offset, since the two real mounts (`Reports/OrderFeedbackReport`,
// `RecoveryAI/Landing`) sit under different amounts of it.
import React, { useRef } from 'react'
import { useStyletron } from 'styletron-react'
import { useViewportTopOffset } from './useViewportTopOffset'

interface Props {
  children: React.ReactNode
}

const HostFlexShell = ({ children }: Props) => {
  const [css] = useStyletron()
  const rootRef = useRef<HTMLDivElement>(null)
  const topOffsetPx = useViewportTopOffset(rootRef)

  return (
    <div
      ref={rootRef}
      className={css({
        display: 'flex',
        flexDirection: 'column',
        // `height`, not `minHeight`: a floor lets this shell grow past the
        // viewport to fit tall content (a long feedback list), which leaves
        // every flex:1/overflow:auto descendant with nothing fixed to clip
        // against, so the page grows instead of the list scrolling
        // internally. A fixed height still lets INBOX_PANES_MIN_HEIGHT_PX
        // (InboxLayout) overflow it on very short viewports and fall back to
        // page scroll, since height alone (no overflow: hidden) doesn't clip.
        height: topOffsetPx > 0 ? `calc(100vh - ${topOffsetPx}px)` : '100vh',
      })}
    >
      {children}
    </div>
  )
}

export default HostFlexShell
